import Component from '../abstracts/Component';
import FixBody from '../utils/FixBody';

export default class CategoryFilterComponent extends Component {
  get SELECTORS() {
    return {
      showMore: '[data-microcategory-menu] [data-show-more]',
      showLess: '[data-microcategory-menu] [data-show-less]',
      secondaryList: '[data-microcategory-menu] [data-secondary-list]',
      submenuPanel: '[data-microcategory-menu] [data-submenu-panel]',
      submenuPanelClose: '[data-microcategory-menu] [data-trigger-close]',
      benefitBar: '[data-benefit-bar]',
      productsCounters: '[data-products-counter]'
    };
  }
  constructor() {
    super();
    this.showMore = document.querySelector(this.SELECTORS.showMore);
    this.showLess = document.querySelector(this.SELECTORS.showLess);
    this.secondaryList = document.querySelector(this.SELECTORS.secondaryList);
    this.submenuPanel = document.querySelector(this.SELECTORS.submenuPanel);
    this.submenuPanelClose = document.querySelector(this.SELECTORS.submenuPanelClose);
    this.productsCounters = document.querySelectorAll(this.SELECTORS.productsCounters);
  }

  // here for sales refactoring
  updateCounter() {
    let ctx = this;
    //
    this.$on(this.$customEvents.FILTERS_EVENTS.pageLoaded, ({event, payload}) => {
      // update products counters
      if(this.productsCounters != null ) {
        this.productsCounters.forEach(function(elem) {
          // i take the html of the first find, and i put inside both of them
          elem.innerHTML = payload.response.querySelector(ctx.SELECTORS.productsCounters).innerHTML;
        });
      }
    });
  }

  bindEvents() {
    let scrollY = 0;
    let benefitBar = document.querySelector(this.SELECTORS.benefitBar);
    let barHeight = benefitBar ? benefitBar.offsetHeight : 0;
    if (this.showMore != null) {
      this.showMore.addEventListener('click', () => {
        if (window.matchMedia('(min-width: 768px)').matches) {
          this.showMore.style.display = 'none';
          this.secondaryList.style.display = 'block';
        } else {
          this.submenuPanel.classList.add('open');
          scrollY = window.scrollY > barHeight ? window.scrollY : barHeight;
          FixBody.block(barHeight);
        }
      });
    }
    if (this.showLess != null) {
      this.showLess.addEventListener('click', () => {
        if (window.matchMedia('(min-width: 768px)').matches) {
          this.showMore.style.display = 'flex';
          this.secondaryList.style.display = 'none';
        }
      });
    }
    if (this.submenuPanelClose != null) {
      this.submenuPanelClose.addEventListener('click', () => {
        this.submenuPanel.classList.remove('open');
        FixBody.unblock(scrollY);
      });
    }
  }

  render() {
    this.log("Rendering...");
    this.bindEvents();
    this.updateCounter();
  }
}
